import { defineComponent as _defineComponent } from 'vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { eventApi, EventDB } from '@/enitites/event'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventDelete',
  props: {
    isShowDelete: { type: Boolean },
    redirectUser: { type: Boolean },
    event: null
  },
  emits: ["update:isShowDelete", "eventDeleted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShowDelete', value: boolean): void
  (e: 'eventDeleted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isShowDelete: boolean
  redirectUser?: boolean
  event: EventDB
};

const router = useRouter()




async function removeEvent() {
  const resp = await eventApi.deleteEvent(props.event.id)
  if (!resp) return
  emit('update:isShowDelete', false)
  emit('eventDeleted')

  if (props.redirectUser) {
    await router.push({ name: 'EventsPage' })
  }
}

return { __sfc: true,router, props, emit, removeEvent, ModalWrapper }
}

})